import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Stack, Button, Popover, MenuItem, Box, Link, Divider } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
// sections
import { LoginForm } from '../sections/auth/login';
import { useCallback, useEffect, useRef, useState } from 'react';
import { glb_sv, sendRequest, serviceList, session, socket_sv } from 'src/utils';
import { useTranslation } from 'react-i18next';
import vi from '../image/language/vi.png';
import en from '../image/language/en.png';
import jp from '../image/language/jp.png';
import logoChips from '../image/logo/logo-svgpng.png';
import Iconify from 'src/components/iconify/Iconify';
import { LoadingButton } from '@mui/lab';
import Loader from 'src/components/loader/loader';
import { ToastContainer, toast } from 'react-toastify';
import crypt from 'src/utils/service/crypt';
import { useNavigate } from 'react-router-dom';
import LoginHikvisionModal from 'src/components/modal/LoginHikvisionModal';

import SignalWifiStatusbarConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import useNetworkRTT from 'src/hooks/useNetworkRTT';
import useCheckConnectionToServer from 'src/hooks/useCheckConnectionToServer';
import { getGeoLocation } from 'src/hooks/useGetLocation';
import { getPublicIP } from 'src/hooks/useIpWan';
import { generateMixedId } from 'src/utils/formatNumber';
import ConfirmModal from 'src/components/modal/ConfirmModal';
// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        overflow: 'hidden',
    },
}));

const StyledSection = styled('div')(({ theme }) => ({
    width: '100%',
    maxWidth: 480,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: theme.customShadows.card,
    backgroundColor: theme.palette.background.default,
    paddingBottom: 5,
}));

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
function Copyright() {
    const version = localStorage.getItem('version');
    return (
        <Typography variant="body2" color="text.secondary">
            {'© ' + ' 2023 OHNOSEIKO.  Powered by '}
            <Link underline="none" color="text.secondary" href="https://chips.vn/">
                <span>Chips v{version}</span>
            </Link>{' '}
        </Typography>
    );
}

export default function LoginPage() {
    const mdUp = useResponsive('up', 'md');
    glb_sv.setClient_tp();
    const [language, setLanguage] = useState(glb_sv.language);

    const navigate = useNavigate();

    const [infoSession, setInfoSession] = useState({ latitude: 0, longitude: 0, ipWan: '', deviceId: '' });
    const [open, setOpen] = useState(null);
    const { t, i18n } = useTranslation();
    const loginRef = useRef(false);
    const [flag, setFlag] = useState(false);
    const [forgotPassword, setForgotPassword] = useState(false);
    const [visibleLoginHik, setVisibleLoginHik] = useState(false);
    const [visibleReload, setVisibleReload] = useState(false);
    const [newVersion, setNewVersion] = useState('');
    const networkRTT = useNetworkRTT();
    const { countDisconect: countConectionServer, setCountDisconect: setCountDisconectServer } =
        useCheckConnectionToServer();
    const [countDisconect, setCountDisconect] = useState(0);
    const [elementConection, setElementConection] = useState(
        <>
            {glb_sv.countConection <= 1 ? (
                <Typography color={'text.success'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Iconify icon={'material-symbols:wifi'} width={20} height={20} />
                </Typography>
            ) : (
                ''
            )}
            {glb_sv.countConection > 1 && glb_sv.countConection <= 2 ? (
                <Typography color={'text.warning'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Iconify icon={'material-symbols:wifi-2-bar-sharp'} width={20} height={20} />
                </Typography>
            ) : (
                ''
            )}
            {glb_sv.countConection >= 3 ? (
                <Typography color={'text.error'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Iconify icon={'material-symbols:wifi-off'} width={20} height={20} />
                </Typography>
            ) : (
                ''
            )}
        </>
    );
    // const cabinetData = useRef({});
    // const [getFlags, setGetFlags] = useState(false);
    // const getRef = useRef(false);

    // navigator.permissions.query({ name: 'geolocation' }).then((result) => {
    //     if (result.state !== 'granted') {
    //         alert('Bạn đã chặn quyền truy cập vị trí. Hãy bật lại trong cài đặt trình duyệt (ⓘ -> Vị trí).');
    //     }
    // });
    const checkVersion = () => {
        const Inval = [];
        console.log('here');
        sendRequest(serviceList.checkVersion, Inval, checkVersionResult, true, timeOutFunct, 20000);
    };

    const checkVersionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
        } else {
            const data = message.proc_data.rows;
            const now_client_version = localStorage.getItem('version');
            if (!now_client_version) {
                localStorage.setItem('version', data);
                return;
            }
            if (data !== now_client_version) {
                setVisibleReload(true);
                setNewVersion(data);
            }
        }
    };

    const handleReload = () => {
        const now_client_version = localStorage.getItem('version');
        if (newVersion != now_client_version) {
            localStorage.setItem('version', newVersion);
            window.location.reload();
        }
    };

    useEffect(() => {
        if (socket_sv?.socket_clt?.connected) {
            checkVersion();
        }
    }, [socket_sv?.socket_clt?.connected]);

    useEffect(() => {
        const fetchInfo = async () => {
            let data = { latitude: 0, longitude: 0 };
            let ipWanData = '';

            try {
                data = localStorage.getItem('geo_location');
                if (!data) {
                    data = await getGeoLocation();
                    localStorage.setItem('geo_location', JSON.stringify(data));
                } else {
                    data = JSON.parse(data);
                }
            } catch (err) {
                console.warn('Geo location failed', err);
            }
            try {
                ipWanData = await getPublicIP();
            } catch (err) {
                console.warn('IP fetch failed', err);
            }

            let deviceId = localStorage.getItem('device_id');
            if (!deviceId) {
                deviceId = generateMixedId();
                localStorage.setItem('device_id', deviceId);
            }

            setInfoSession({
                deviceId: deviceId,
                ipWan: ipWanData,
                latitude: data.latitude,
                longitude: data.longitude,
            });
        };

        fetchInfo();
    }, []);

    useEffect(() => {
        let language = localStorage.getItem(session.LOCAL_LANGUAGE);
        if (!language) language = 'vi';
        i18n.changeLanguage(language);
        setLanguage(language);
        glb_sv.language = language;
    }, []);

    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClose = (lange) => {
        setOpen(null);
        glb_sv.language = lange;
        i18n.changeLanguage(lange);
        setLanguage(lange);
        localStorage.setItem(session.LOCAL_LANGUAGE, lange);
    };

    const loginRFID = () => {
        const chooseCabinetLocal = glb_sv.getLocalStorageCabinet('cabinet');
        if (!chooseCabinetLocal) {
            toast.error('Error: ' + t('err_login_rfid'));
            return;
        }
        if (loginRef.current) return;
        setFlag(true);
        loginRef.current = true;
        const service =
            chooseCabinetLocal?.cabinet_type !== 'round' ? serviceList.getRFID : serviceList.getRFIDCabinetV2;
        const inpuVal = [chooseCabinetLocal?.cabinet_cd];
        sendRequest(service, inpuVal, loginRFIDResult, true, timeOutFunctIOTCloseCell, 40000, 0);
    };

    const loginRFIDResult = (reqInfoMap, message) => {
        // console.log(message);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message'], { autoClose: 10000 });
            setFlag(false);
            loginRef.current = false;
        } else {
            const codeRFID = message['proc_data'][0] || null;
            const cabinetCode = message['proc_data'][1] || null;
            if (cabinetCode) sessionStorage.setItem('cabinetCode', cabinetCode);
            login(codeRFID);
        }
    };

    const timeOutFunctIOTCloseCell = (reqInfo) => {
        setFlag(false);
        loginRef.current = false;
        toast.error(t('error.time_out') + ' IOT');
    };

    const login = (rfid) => {
        if (!rfid) return toast.error(t('not_find_rfid_code'));
        const InVal = [rfid];
        sendRequest(serviceList.loginRFID, InVal, loginResult, true, timeOutFunct, 40000);
    };

    const loginResult = (reqInfoMap, message) => {
        setFlag(false);
        loginRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message'], { autoClose: 10000 });
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            const menu = message.proc_data.rows[0].o_2;
            if (data && menu) {
                const enCode = crypt.enCode(JSON.stringify(message.proc_data.rows[0].o_1));
                const enCodeMenu = crypt.enCode(
                    JSON.stringify([
                        ...message.proc_data.rows[0].o_2,
                        {
                            navigate: '/home/category/',
                            screens: 'Giỏ hàng',
                            screens_key: 'gio_hang',
                            user_id: 0,
                            permiss_screen: {},
                            company_id: 100,
                            id: 100,
                            department_id: 100,
                            icons: 'material-symbols:shopping-cart',
                        },
                    ])
                );
                sessionStorage.setItem('proc_data', enCode);
                sessionStorage.setItem('menu', enCodeMenu);
                glb_sv.sessionInfo.comp_id = data.o_3;
                glb_sv.sessionInfo.branch_id = data.o_4;
                glb_sv.sessionInfo.user_id = data.id;

                glb_sv.userInfo = data;
                glb_sv.menu = menu;
                loginIOT();
                navigate('/home', { replace: true });
            } else {
                toast.error(t('system_reject_login'));
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        setFlag(false);
        loginRef.current = false;
        toast.error(t('error.time_out'));
    };

    // region CALL API login IOT

    const loginIOT = () => {
        const cabinet_cd = glb_sv.getLocalStorageCabinet('cabinet');
        // console.log('cabinet_cd', cabinet_cd);
        sendRequest(
            serviceList.loginIOT,
            [cabinet_cd?.cabinet_cd || ''],
            loginIOTResult,
            true,
            timeOutFunctIOT,
            10000,
            0
        );
    };
    const loginIOTResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            toast.success('Error: ' + message['proc_message']);
        }
    };
    const timeOutFunctIOT = (e) => {
        toast.error(t('error.time_out') + ' IOT');
    };
    useEffect(() => {
        if (!networkRTT || networkRTT >= 300) {
            setCountDisconect(2);
            renderStatusWifi(2);
            setCountDisconectServer(2);
        } else if (networkRTT >= 120 && networkRTT) {
            setCountDisconect(1);
        } else {
            setCountDisconect(0);
        }
    }, [networkRTT]);

    useEffect(() => {
        if (countConectionServer === 0) {
            renderStatusWifi(countDisconect);
            // setCountDisconectServer(countDisconect);
        } else {
            renderStatusWifi(countConectionServer);
        }
    }, [countConectionServer, countDisconect]);

    const renderStatusWifi = useCallback(
        (count = 0) => {
            if (count < 1) {
                setElementConection(
                    <Typography
                        color={'text.success'}
                        data={countDisconect}
                        sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                    >
                        <Iconify icon={'material-symbols:wifi'} width={20} height={20} />
                    </Typography>
                );
            }
            if (count >= 1 && count < 2) {
                setElementConection(
                    <Typography
                        data={countDisconect}
                        color={'text.warning'}
                        sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                    >
                        <SignalWifiStatusbarConnectedNoInternet4Icon width={20} height={20} />
                    </Typography>
                );
            }
            if (count >= 2) {
                setElementConection(
                    <Typography color={'text.error'} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                        <WifiOffIcon width={20} height={20} />
                    </Typography>
                );
            }
        },
        [countDisconect]
    );

    const getNetworkRTTColor = (networkRTT) => {
        if (networkRTT > 300) return 'red';
        if (networkRTT > 120) return 'yellow';
        return 'inherit'; // hoặc màu mặc định
    };

    return (
        <>
            <Helmet>
                <title> {t('home')} </title>
            </Helmet>

            {/* Custom react-toastify */}
            {/* <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            /> */}
            <ConfirmModal
                loading={false}
                visible={visibleReload}
                setVisible={setVisibleReload}
                handleDelete={handleReload}
                mesages={'request_reload'}
                typeButtonConfirm="confirm"
                titleButtonConfirm="confirm"
                closeCancle={true}
                canCloseOutSide={false}
            />
            <LoginHikvisionModal
                infoSession={infoSession}
                setInfoSession={setInfoSession}
                visible={visibleLoginHik}
                setVisible={setVisibleLoginHik}
            />
            <Loader loading={flag} />
            <StyledRoot>
                {mdUp && (
                    <StyledSection>
                        <Typography variant="h3" sx={{ px: 5, mt: 5, mb: 2 }}>
                            {t('welcome_back')}
                        </Typography>
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <img
                                style={{ width: '64%', mixBlendMode: 'multiply' }}
                                src="/assets/illustrations/file.png"
                                alt="login"
                            />
                        </div>
                    </StyledSection>
                )}

                <Container maxWidth="sm">
                    <StyledContent>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                // border: '1px solid red',
                                position: 'relative',
                            }}
                        >
                            {/* <img
                                src={logoChips}
                                alt=""
                                style={{
                                    width: '25%',
                                    // border: '1px solid red',
                                    position: 'absolute',
                                    top: '-180%',
                                }}
                            /> */}
                            <Typography variant="h3" gutterBottom color={'red'}>
                                {t('Smart Cabinet')}
                            </Typography>
                        </Box>
                        <Stack sx={{ mb: 2 }} direction="row" justifyContent={'space-between'} spacing={2}>
                            <Typography variant="h4" gutterBottom>
                                {forgotPassword ? t('forgot_pass') : t('login')}
                            </Typography>
                            {language === 'vi' && (
                                <Button variant="text" onClick={handleOpen}>
                                    <img src={vi} alt="" width={40} style={{ borderRadius: '2px' }} />
                                </Button>
                            )}
                            {language === 'en' && (
                                <Button variant="text" onClick={handleOpen}>
                                    <img src={en} alt="" width={40} />
                                </Button>
                            )}
                            {language === 'jp' && (
                                <Button variant="text" onClick={handleOpen}>
                                    <img src={jp} alt="" width={40} />
                                </Button>
                            )}
                            <Popover
                                open={Boolean(open)}
                                anchorEl={open}
                                onClose={() => setOpen(null)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                PaperProps={{
                                    sx: {
                                        p: 1,
                                        mt: 1.5,
                                        ml: 0.75,
                                        width: 180,
                                        '& .MuiMenuItem-root': {
                                            px: 1,
                                            typography: 'body2',
                                            borderRadius: 0.75,
                                        },
                                    },
                                }}
                            >
                                <Stack spacing={0.75}>
                                    <MenuItem selected={language === 'vi'} onClick={() => handleClose('vi')}>
                                        <Box component="img" src={vi} sx={{ width: 28, mr: 2 }} />
                                        Việt Nam
                                    </MenuItem>
                                    <MenuItem selected={language === 'en'} onClick={() => handleClose('en')}>
                                        <Box component="img" src={en} sx={{ width: 28, mr: 2 }} />
                                        English
                                    </MenuItem>
                                    <MenuItem selected={language === 'jp'} onClick={() => handleClose('jp')}>
                                        <Box component="img" src={jp} sx={{ width: 28, mr: 2 }} />
                                        Japan
                                    </MenuItem>
                                </Stack>
                            </Popover>
                        </Stack>
                        {!forgotPassword && (
                            <Stack>
                                <Stack
                                    component="span"
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                    my={1}
                                >
                                    {/* <LoadingButton
                                        // fullWidth
                                        size="large"
                                        color="inherit"
                                        variant="contained"
                                        sx={{ width: '100%' }}
                                        onClick={loginRFID}
                                    >
                                        <Iconify icon="entypo:v-card" color="#058373" width={22} height={22} />
                                        <Typography variant="body2" sx={{ color: '#058373', paddingLeft: 1 }}>
                                            RFID
                                        </Typography>
                                    </LoadingButton> */}
                                    <LoadingButton
                                        // fullWidth
                                        size="large"
                                        color="inherit"
                                        variant="contained"
                                        sx={{ width: '100%' }}
                                        onClick={() => {
                                            setVisibleLoginHik(true);
                                        }}
                                    >
                                        <Iconify
                                            icon="solar:face-scan-square-bold"
                                            color="#058373"
                                            width={22}
                                            height={22}
                                        />
                                        <Typography variant="body2" sx={{ color: '#058373', paddingLeft: 1 }}>
                                            HIKVISION
                                        </Typography>
                                    </LoadingButton>
                                </Stack>
                                <Divider sx={{ my: 3 }}>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        {t('or')}
                                    </Typography>
                                </Divider>
                            </Stack>
                        )}
                        <LoginForm
                            infoSession={infoSession}
                            isForgotPassword={forgotPassword}
                            setForgotPassword={setForgotPassword}
                        />
                    </StyledContent>
                </Container>
            </StyledRoot>
            <Box
                component="footer"
                sx={{
                    py: 1,
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,

                    px: 1,
                    mt: 'auto',
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800],
                }}
            >
                <Container maxWidth="xl">
                    <Stack
                        sx={{
                            display: 'flex',
                            flexDirection: !mdUp ? 'column' : 'row', // Chuyển sang hàng dọc trên mobile
                            justifyContent: !mdUp ? 'center' : 'space-between',
                            alignItems: 'center',
                            textAlign: 'center',
                            gap: !mdUp ? 1 : 0,
                        }}
                    >
                        {!mdUp && (
                            <Typography
                                variant="div"
                                sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                                color="text.secondary"
                            >
                                <strong>{t('status_conection')}:</strong>{' '}
                                <Typography variant="span" sx={{ color: getNetworkRTTColor(networkRTT) }}>
                                    {networkRTT} ms
                                </Typography>
                                {elementConection}
                            </Typography>
                        )}

                        {!mdUp && (
                            <Typography variant="body2" color="text.secondary">
                                <strong>NO:</strong> {infoSession.deviceId}
                            </Typography>
                        )}

                        <Copyright />

                        {mdUp && (
                            <Typography
                                variant="div"
                                sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}
                                color="text.secondary"
                            >
                                <strong>NO:</strong> {infoSession.deviceId} <strong>{t('status_conection')}:</strong>{' '}
                                <Typography variant="span" sx={{ color: getNetworkRTTColor(networkRTT) }}>
                                    {networkRTT} ms
                                </Typography>
                                {elementConection}
                            </Typography>
                        )}
                    </Stack>
                </Container>
            </Box>
        </>
    );
}
